
import { useState } from "react";
import { trackTripCardAction } from "@/utils/analytics";

export const useLoungeData = (tripId: string, destinationName: string) => {
  const [showLounge, setShowLounge] = useState(false);

  const openLoungeWebview = () => {
    trackTripCardAction("lounge", tripId, destinationName);
    setShowLounge(true);
  };

  return {
    showLounge,
    setShowLounge,
    openLoungeWebview
  };
};
